module.exports = __webpack_public_path__ + "img/Improve Outcomes.fa3fe9f8.png";